import React from 'react';
import axios from 'axios';
import {Link} from 'react-router';
import urlBase from '../../url-base';
import { FormGroup, Input, Row, Col } from 'reactstrap';

class FindDentist extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      listOfStates:[],
      listOfMunicipalities: [],
      listOfDistrict: [],
    };

    this.styles = {
      
    };
  }

  componentWillMount() {
    axios.get(urlBase.loopBack+'APIS4s/UFs')
    .then((result) => {
      let state = this.state;

      for (let i = result.data.length - 1; i >= 0; --i) {
        let atuacao = ["PB", "PE", "RN"];
        let sigla = atuacao.indexOf(result.data[i].Sigla);
        if (sigla=='-1') {
          result.data.splice(i, 1);
        }
      }

      state.listOfStates = result.data;

      // state.listOfStates = result.data.filter(function (obj) {
      //   return obj.Sigla !== 'PB' || obj.Sigla !== 'RN' || obj.Sigla !== 'PE' ;
      // });

     
     
      this.setState(state);
    })
    .catch(function (erro) {
      // Tratar esse erro
      console.log(erro);
    });
  }
  //busca cidade
  findCity() {
    document.getElementById('loading_i_selecione_cidade').style.display = 'block';

    let	url = urlBase.loopBack+'APIS4s/Municipios';
    let idState = parseInt(document.getElementById('i_select_states').value);
    
    let	dataPost = {
      idUF: idState//setando id do estado
    };
    
    axios.post(url, dataPost)
    .then((result) => {
      let state = this.state;
      state.listOfMunicipalities = result.data;
      this.setState(state);
      document.getElementById('loading_i_selecione_cidade').style.display = 'none';
      document.getElementById('col_i_selecione_cidade').style.display = 'block';
    })
    .catch(function (erro) {
      alert(erro);
    });
  }
  // busca bairro
  findDistrict() {
    document.getElementById('loading_i_selecione_bairro').style.display = 'block';

    let	url = urlBase.loopBack+'APIS4s/Bairros';
    let idDistrict = parseInt(document.getElementById('i_selecione_cidade').value);
    
    let	dataPost = {
      idCity: idDistrict//id do bairro
    };

    axios.post(url, dataPost)
    .then((result) => {
      let state = this.state;
      state.listOfDistrict = result.data;
      this.setState(state);
      document.getElementById('loading_i_selecione_bairro').style.display = 'none';
      document.getElementById('col_i_selecione_bairro').style.display = 'block';
    })
    .catch(function (erro) {
      alert(erro);
    });
  }

  viewButton() {
    document.getElementById('i_button_dentist').style.display = 'block';
  }

  //faz a busca da rede credenciada
  findSubmit(){
    let idState = parseInt(document.getElementById('i_select_states').value),
        idCity = parseInt(document.getElementById('i_selecione_cidade').value),
        idDistrict = parseInt(document.getElementById('i_selecione_bairro').value);
        
    /* if(Number.isNaN(idDistrict)){//caso o usuario nao forneca o bairro
      idDistrict = -1;
    }  
    if(Number.isNaN(idCity)){//caso o usuario nao forneca o cidade
      idCity = -1;
    } */
    sessionStorage.setItem("id_state_rede", idState);
    sessionStorage.setItem("id_city_rede", idCity);
    sessionStorage.setItem("id_district_rede", idDistrict);
    
  }

  render() {

    return (
      <div id="component_find_dentist">
        <div id="find_dentist_img">&nbsp;</div>

        <div className="select_dentist">
          <hr className="hr_style2"/>
          <p className="title_dentist">ENCONTRE DENTISTAS<br/>PERTO DE VOCÊ</p>
          <div id="find_yellow">&nbsp;</div>
          <Row style={{marginTop:70}}>
            <Col>
              <div id="choose_city_dentist" className="acrylic_dentist">
                <FormGroup id="arrow_dentist" style={{margin:0, textAlign:'center'}}>
                  <Input
                    id="i_select_states"
                    style={{width: '100%', maxHeight:60}}
                    type="select"
                    onChange={this.findCity.bind(this)}>
                  >
                    <option id="options" value={-1} >SELECIONE SEU ESTADO</option>
                    {this.state.listOfStates.map(item =>
                      <option key={item.Id} value={item.Id}>{item.Sigla}</option>
                    )}
                  </Input>
                </FormGroup>
              </div>
            </Col>
          </Row>
          <Row style={{marginTop:20}}>
            <Col>
              <div>
                <i id="loading_i_selecione_cidade"
                  style={{ display: 'none', width: 16, margin: '0 auto 8px auto'}}
                  className="fa fa-spinner fa-spin">
                  &nbsp;
                </i>
              </div>
              <div id="col_i_selecione_cidade" style={{display: 'none'}}>
                <div id="choose_city_dentist" className="acrylic_dentist">
                  <FormGroup id="arrow_dentist"  style={{margin:0, textAlign:'center'}}>
                    <Input
                      id="i_selecione_cidade"
                      style={{width: '100%', maxHeight:60}}
                      type="select"
                      onChange={this.findDistrict.bind(this)}>
                      <option>SELECIONE SUA CIDADE</option>
                      { 
                        this.state.listOfMunicipalities.map((item, index) =>
                          document.getElementById('i_select_states').value == '14' ? (
                            index < 8 ? (// Cidades mais importantes
                      <option key={index} value={item.Id}>{item.Nome}</option>
                            ) : (// Restante das cidades
                              index > 8 ? (
                      <option key={index} value={item.Id}>{item.Nome}</option>
                              ) : (// Divisão
                      <optgroup key={index} label="----------">{''}</optgroup>
                              )
                            )
                          ) : (// Outros estados
                      <option key={index} value={item.Id}>{item.Nome}</option>
                          )
                      )}
                    </Input>
                  </FormGroup>
                </div>
              </div>
            </Col>
          </Row>
          <Row style={{marginTop:20}}>
            <Col>
              <div>
                <i id="loading_i_selecione_bairro"
                  style={{ display: 'none', width: 16, margin: '0 auto 8px auto'}}
                  className="fa fa-spinner fa-spin">
                  &nbsp;
                </i>
              </div>
              <div id="col_i_selecione_bairro" style={{display: 'none'}}>
                <div id="choose_city_dentist" className="acrylic_dentist">
                  <FormGroup id="arrow_dentist" style={{margin:0, textAlign:'center'}}>
                    <Input
                      id="i_selecione_bairro"
                      style={{width: '100%', maxHeight:60}}
                      type="select"
                      onChange={this.viewButton.bind(this)}>
                    >
                      <option>SELECIONE SEU BAIRRO</option>
                      { 
                        this.state.listOfDistrict.map(item =>
                          <option key={item.Id} value={item.Id}>{item.Nome}</option>
                        )               
                      }
                    </Input>
                  </FormGroup>
                </div>
              </div>
            </Col>
          </Row>

          <div id="i_button_dentist" style={{display: 'none'}}>
            <Link to={urlBase.client+"accreditednetwork"} onClick={this.findSubmit.bind(this)}  >
              <div className="button_dentist"><span >BUSCAR</span></div>
            </Link>
          </div>
        </div> 
      </div>
    );

  }

}

export default FindDentist;
/* <FormGroup className="choose_select">
              <Input id="i_selecione_cidade" type="select" name="select" 
                     onChange={this.findDistrict.bind(this)}>
                <option>SELECIONE SUA CIDADE</option>
                { 
                  this.state.listOfMunicipalities.map(item =>
                    <option key={item.Id} value={item.Id}>{item.Nome}</option>
                  )               
                }
              </Input>
            </FormGroup>
            <FormGroup className="choose_select">
              <Input id="i_selecione_bairro" type="select" name="select">
                <option>SELECIONE SEU BAIRRO</option>
                { 
                  this.state.listOfDistrict.map(item =>
                    <option key={item.Id} value={item.Id}>{item.Nome}</option>
                  )               
                }
              </Input>
            </FormGroup>*/


/** WEBPACK FOOTER **
 ** ./src/components/HomePageNew/FindDentist.js
 **/